/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens.
 * Enables TAB key navigation support for dropdown menus.
 * Moves Utility menu in DOM for mobile/desktop
 */
 ( function() {
	const siteNavigation = document.getElementById( 'site-navigation' ),
		  utilityEl = document.getElementById('utility'),
		  primaryMenuEl = document.getElementById('primary-menu'),
		  siteBrandingEl = document.getElementById('site-branding'),
		  partnershipsEl = document.getElementById('partnerships');

	// Return early if the navigation don't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const button = siteNavigation.getElementsByTagName( 'button' )[ 0 ];

	// Return early if the button don't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	if ( ! menu.classList.contains( 'nav-menu' ) ) {
		menu.classList.add( 'nav-menu' );
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener( 'click', function() {
		siteNavigation.classList.toggle( 'toggled' );

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
			document.body.style.overflow = 'scroll';
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
			document.body.style.overflow = 'hidden';
		}
	} );

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener( 'click', function( event ) {
		const isClickInside = siteNavigation.contains( event.target );

		if ( ! isClickInside ) {
			siteNavigation.classList.remove( 'toggled' );
			button.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName( 'a' );

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

	// Toggle focus each time a menu link is focused or blurred.
	for ( const link of links ) {
		link.addEventListener( 'focus', toggleFocus, true );
		link.addEventListener( 'blur', toggleFocus, true );
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for ( const link of linksWithChildren ) {
		link.addEventListener( 'touchstart', toggleFocus, { passive: true } );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if ( event.type === 'focus' || event.type === 'blur' ) {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while ( ! self.classList.contains( 'nav-menu' ) ) {
				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					self.classList.toggle( 'focus' );
				}
				self = self.parentNode;
			}
		}

		if ( event.type === 'touchstart' ) {
			const menuItem = this.parentNode;
			event.preventDefault();
			for ( const link of menuItem.parentNode.children ) {
				if ( menuItem !== link ) {
					link.classList.remove( 'focus' );
				}
			}
			menuItem.classList.toggle( 'focus' );
		}
	}

	/**
	 * Creates mobile menu container and moves primary menu into it.
	 */
	const mobilePrimaryMenu = () => {
		var mobileMenuContainer = document.createElement('div');
		mobileMenuContainer.setAttribute('id', 'mobile-menu-container');
		mobileMenuContainer.setAttribute('class', 'mobile-menu-container');
		siteNavigation.appendChild(mobileMenuContainer);
		mobileMenuContainer.appendChild(primaryMenuEl);
	}

	/**
	 * Adds arrow to mobile menu items with children
	 */
	const mobilePrimaryMenuItems = () => {
		let menuItem = document.querySelectorAll('.mobile-menu-container .primary-menu > .menu-item-has-children');

		menuItem.forEach(function(menuItem) {
			let menuArrow = document.createElement('span');
			menuArrow.setAttribute('class', 'nav-arrow');
			menuArrow.setAttribute('tabindex', '0');
			menuItem.appendChild(menuArrow);
		});
	}

	/**
	 * Toggle Mobile Submenu
	 */
	 const toggleSubMenus = () => {
		let subMenuToggle = document.querySelectorAll('.nav-arrow');

		subMenuToggle.forEach(function(subMenuToggle) {

			//Show submenu when click on menu item with children
			subMenuToggle.addEventListener( 'click', function() {
				let submenu = subMenuToggle.previousElementSibling;
				submenu.classList.add('sub-menu--active');
			} );
		});
	}

	/**
	 * Toggle Mobile Submenu
	 */
	 const parentMenuItem = () => {
		let submenu = document.querySelectorAll('.mobile-menu-container .primary-menu > .menu-item-has-children > .sub-menu');

		submenu.forEach(function(submenu) {
			let parentMenuItem = submenu.previousElementSibling;
			let parentMenuItemText = parentMenuItem.textContent;
			let parentMenuItemEl = document.createElement('span');
			parentMenuItemEl.setAttribute('class', 'parent-menu-item');
			parentMenuItemEl.append(parentMenuItemText);
			submenu.append(parentMenuItemEl);
		});

		let submenuBack = document.querySelectorAll('.mobile-menu-container .primary-menu > .menu-item-has-children > .sub-menu > .back-container');

		submenuBack.forEach(function(submenuBack) {
			let parentMenuItemEl = submenuBack.nextElementSibling;
			submenuBack.append(parentMenuItemEl);
		});
	}

	/**
	 * Submenu Back Arrow
	 */
	 const backArrow = () => {
		//add a back arrow to submenu
		let submenu = document.querySelectorAll('.mobile-menu-container .primary-menu > .menu-item-has-children > .sub-menu');

		submenu.forEach(function(submenu) {
			let backContainer = document.createElement('span');
			backContainer.setAttribute('class', 'back-container');
			backContainer.setAttribute('tabindex', '0');

			let backArrow = document.createElement('span');
			backArrow.setAttribute('class', 'back-arrow');
			backContainer.appendChild(backArrow);
			submenu.appendChild(backContainer);
		});

		//Remove active class from submenu when click on back arrow
		let backArrow = document.querySelectorAll('.back-arrow');
		submenu = document.querySelectorAll('.mobile-menu-container .primary-menu > .menu-item-has-children > .sub-menu');

		backArrow.forEach(function(backArrow) {
			backArrow.addEventListener( 'click', function() {
				submenu.forEach(function(submenu) {
					submenu.classList.remove('sub-menu--active');
				});
			});
		});
	}

	/**
	 * Moves main menu back to desktop position.
	 */
    const desktopPrimaryMenu = () => {
        siteNavigation.appendChild(primaryMenuEl);
	}

	/**
	 * Moves utility to be after primary menu.
	 */
    const mobileUtility = () => {
        if (utilityEl) {
            primaryMenuEl.after(utilityEl);
        }
	}

	/**
	 * Moves utility menu back to desktop position and removes mobile menu container.
	 */
	const desktopUtility = () => {
        if (utilityEl) {
            siteBrandingEl.before(utilityEl);
            siteNavigation.classList.remove('toggled');
        }

        document.getElementById('mobile-menu-container').remove();
        document.body.style.overflow = 'scroll';
	}

	/**
	 * Toggle Mobile Footer Submenu
	 */
	const toggleFooterSubMenus = () => {
		let footerSubMenuToggle = document.querySelectorAll('.site-footer .menu-heading');


		footerSubMenuToggle.forEach(function(footerSubMenuToggle) {
			let footerSubmenu = footerSubMenuToggle.nextElementSibling;
			let height = footerSubmenu.offsetHeight;
			footerSubmenu.style.height = 0;

			//Show submenu when click on menu item with children
			footerSubMenuToggle.addEventListener( 'click', function() {
				let footerSubmenu = footerSubMenuToggle.nextElementSibling;

				if (footerSubmenu.offsetHeight === 0) {
					footerSubmenu.style.height = height + 'px';
				} else {
					footerSubmenu.style.height = 0;
				}
			} );
		});
	}

	/**
	 * Show Mobile Footer Submenu
	 */
	const showFooterSubMenus = () => {
		let footerSubmenu = document.querySelectorAll('.site-footer nav');
		footerSubmenu.forEach(function(footerSubmenu) {
			footerSubmenu.style.height = 'auto';
		});
	}

	/**
	 * Moves partnership logo
	 */
	 const footerPartnersMobile = () => {
		let subscribe = document.getElementById('subscribe-container');

		subscribe.appendChild(partnershipsEl);

	}

	const footerPartnersDesktop = () => {
		let footerTop = document.querySelector('.site-footer__top-container');

		footerTop.appendChild(partnershipsEl);
	}

	/**
	 * Handles function calls in major breakpoints.
	 */
	const initEnquire = () => {

		enquire.register("screen and (max-width:767px)", {
            match : function() {
				toggleFooterSubMenus();
            },
            unmatch : function() {
				showFooterSubMenus();
            }
        });

        enquire.register("screen and (max-width:1023px)", {
            match : function() {
                mobilePrimaryMenu();
                mobileUtility();
				mobilePrimaryMenuItems();
				toggleSubMenus();
				backArrow();
				parentMenuItem();
            },
            unmatch : function() {
                desktopPrimaryMenu();
                desktopUtility();
            }
        });

		enquire.register("screen and (min-width:1340px)", {
            match : function() {
				footerPartnersDesktop();
            },
            unmatch : function() {
				footerPartnersMobile();
            }
        });
	}

	document.addEventListener("DOMContentLoaded", () => {
        initEnquire();
    });

}() );
